<template>
  <div style="font-family: poppinsregular">
    <vue-element-loading
      :active="appLoading"
      :is-full-screen="true"
      background-color="#FFFFFF"
      color="#FDAC53"
      spinner="bar-fade-scale"
    />
    <ServerError v-if="ServerError" />
    <v-snackbar
      v-model="showSnackBar"
      color="black"
      rounded
      centered
      timeout="2000"
    >
      <v-layout wrap justify-center>
        <v-flex text-center class="align-self-center">
          <span style="color: #ffffff">
            {{ msg }}
          </span>
        </v-flex>
      
      </v-layout>
    </v-snackbar>
    <v-layout wrap pb-3>
      <v-flex xs12 text-left>
        <span style="color: #000; font-size: 20px; font-family: poppinsbold"> Q & A - &nbsp;  {{
          this.$route.query.shop
        }}</span>
      </v-flex>
    </v-layout>
    <v-layout v-for="(item, i) in Qlist" :key="i" pt-1>
      <v-flex>
        <v-card>
          <v-layout wrap pa-3>
            <v-flex xs2 lg1 text-left>
              <v-avatar x-large v-if="item.productId.photo != null">
                <v-img :src="mediaURL + item.productId.photo"> </v-img>
              </v-avatar>
            </v-flex>
            <v-flex xs4 lg5 text-left>
              <v-layout wrap>
                <v-flex xs12>
                  <b>
                    <router-link
                      :to="'/groceryProductInfo?id=' + item.productId._id"
                    >
                      {{ item.productId.varientName }}
                    </router-link>
                  </b>
                  <br />
                  Rs. <span>{{ item.productId.price }}</span> &nbsp;
                  <span
                    v-if="item.productId.price != item.productId.offerPrice"
                  >
                    <del> {{ item.productId.offerPrice }}</del>
                  </span>
                </v-flex>
                <v-flex xs12 pb-2>
                  <v-divider></v-divider>
                </v-flex>
                <v-flex xs12 style="font-size: 12px">
                  <b>From: &nbsp;&nbsp;</b>

                  <router-link :to="'/CustomerInfo?customer=' + item.uid._id">
                    <span
                      >{{ item.uid.customerid.firstName }} &nbsp;{{
                        item.uid.customerid.lastName
                      }}</span
                    >
                  </router-link>
                  <br />
                  <b>Phone:&nbsp;&nbsp;</b>
                  <span>{{ item.uid.phone }} </span> <br />
                  <b>Email:&nbsp;&nbsp;</b>
                  <span>{{ item.uid.customerid.email }} </span>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-divider vertical></v-divider>
            <v-flex xs6 px-5>
              <v-layout wrap>
                <v-flex xs12 text-left pb-3 pr-lg-5>
                  <v-card
                    elevation="1"
                    class="py-2 px-4"
                    style="border-radius: 20px"
                    color="#e6e6e6"
                  >
                    <b> {{ item.question }} </b>
                  </v-card>
                </v-flex>
                <v-flex xs12 pl-lg-5>
                  <v-textarea
                    hide-details
                    height="100px"
                    background-color="#d9f2d9"
                    solo
                    v-model="item.answer"
                    style="border-radius: 20px !important"
                  >
                  </v-textarea>
                </v-flex>
                <v-flex xs12 text-right pt-2>
                  <v-btn
                    small
                    rounded
                    color="#53c653"
                    @click="sentMsg(item, i)"
                  >
                    <v-icon small color="white">mdi-send</v-icon>
                  </v-btn>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
    </v-layout>
    <v-layout wrap pt-3>
      <v-flex xs12>
        <v-pagination
          :length="pages"
          :total-visible="8"
          v-model="currentPage"
          color="#FDAC53"
        ></v-pagination>
      </v-flex>
    </v-layout>
  </div>
</template>


<script>
import axios from "axios";
export default {
  data() {
    return {
      pages: 0,
      currentPage: 1,
      Qlist: [],
      appLoading: false,
      showSnackBar: false,
      msg: "",
      ServerError:false,
    };
  },
  watch: {
    currentPage() {
      this.getData();
    },
  },

  mounted() {
    this.getData();
  },

  methods: {
    getData() {
      this.appLoading = true;
      axios({
        method: "POST",
        url: "/grocery/admin/answer/view/list",
        headers: {
          token: localStorage.getItem("token"),
        },
        data: {
          limit: 25,
          sellerId: this.$route.query.id,
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status) {
            this.Qlist = response.data.data;
            this.pages = Math.ceil(response.data.length / 25);
          } else {
            this.appLoading = false;
            this.msg = response.data.msg;

            this.showSnackBar = true;
          }
        })
        .catch(() => {
          this.appLoading = false;
          this.ServerError = true;
        });
    },
    sentMsg(val, index) {
      this.loading = true;
      axios({
        method: "POST",
        url: "/grocery/answer/question",
        headers: {
          token: localStorage.getItem("token"),
        },
        data: {
          id: val._id,
          answer: val.answer,
        },
      })
        .then((response) => {
          this.loading = false;
          if (response.data.status) {
            this.msg = "Message Sent";
            this.showSnackBar = true;
          } else {
            this.appLoading = false;
            this.msg = response.data.msg;
            this.showSnackBar = true;
            this.Qlist[index].answer = "";
          }
        })
        .catch(() => {
          this.appLoading = false;
          this.ServerError = true;

        });
    },
  },
};
</script>